import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient } from '@/services/core/apiClient';
import { useErrorHandler } from '@/hooks/useErrorHandler';

interface UseDeleteUserResult {
  deleting: boolean;
  deleteUser: (userId: number) => Promise<boolean>;
}

export const useDeleteUser = (): UseDeleteUserResult => {
  const { token, user: authUser } = useAuth();
  const { handleError, handleSuccess } = useErrorHandler();
  const [deleting, setDeleting] = useState(false);

  const deleteUser = async (userId: number): Promise<boolean> => {
    if (!authUser?.id || !userId) {
      handleError('Authentication required');
      return false;
    }

    setDeleting(true);

    try {
      const endpoint = `/api/ngpep/${authUser.id}/ed/${userId}`;
      const response = await apiClient.delete(endpoint, token);

      if (response.success) {
        handleSuccess('User deleted successfully');
        return true;
      } else {
        handleError(response.error || 'Failed to delete user');
        return false;
      }
    } catch (err) {
      handleError(err, 'Failed to delete user');
      return false;
    } finally {
      setDeleting(false);
    }
  };

  return {
    deleting,
    deleteUser,
  };
};
